import React from 'react'
import _ from 'underscore'
import { TriangleAlert, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import EditEnquiryLearnerSubject from './edit'
import store from '../../../state/store'

class EnquiryLearnerSubjectsPartial extends React.Component {

  constructor(props) {
    super(props)
    
    this.state = {
      editing: false
    }
  }

  onClick = () => {
    if (this.state.editing === false) {
      this.setState({editing: true})
    }
  }

  onSaved = () => {
    this.setState({editing: false})
  }

  onCreateLessonPlan = () => {
    store.emit('enquiry:lesson_plans:create', this.props.subject.enquiry_id, {
      enquiry_subject_ids: [this.props.learner_subject.enquiry_subject_id],
      enquiry_learner_ids: [this.props.learner_subject.enquiry_learner_id]
    })
  }

  onRemove = () => {
    store.emit('enquiry:learner_subjects:destroy', this.props.subject.enquiry_id, this.props.learner_subject.id)
  }

  render() {
    if (this.state.editing) {
      return (
        <EditEnquiryLearnerSubject
          enquiry_id={this.props.subject.enquiry_id}
          learner_subject_id={this.props.learner_subject.id}
          subject_name={this.props.subject.name}
          subject_category_name={this.props.subject.subject_category_name}
          subject_level_name={this.props.subject.subject_level_name}
          syllabus={this.props.subject.syllabus}
          result={this.props.learner_subject.result}
          focus_areas={this.props.learner_subject.focus_areas}
          country_code={this.props.country_code}
          onSaved={this.onSaved}
        />
      )
    }

    return (
      <div className="mb-2 rounded-[10px] border border-border bg-card hover:bg-muted/50">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2 px-4 py-3 text-sm">
          <div className="flex min-w-0 flex-1 cursor-pointer items-center gap-2" onClick={this.onClick}>
            {!this.props.subject.known && (
              <span className="shrink-0" title='Unknown subject: check that the name, category and level match known information.'>
                <TriangleAlert className="size-4 text-amber-600" aria-hidden="true"/>
              </span>
            )}
            <div className="flex min-w-0 flex-col leading-tight">
              <span className="font-medium">
                {this.props.subject.name}
                {this.props.subject.syllabus ? <span className="font-normal text-muted-foreground"> ({this.props.subject.syllabus})</span> : null}
              </span>
              <span className="text-xs text-muted-foreground">{this.props.subject.subject_level_name} {this.props.subject.subject_category_name}</span>
            </div>
          </div>
          {this.props.learner_subject.focus_areas && (
            <span className="cursor-pointer whitespace-nowrap text-xs italic text-muted-foreground" onClick={this.onClick}>
              {this.props.learner_subject.focus_areas}
            </span>
          )}
          {(this.props.learner_subject.result || this.props.learner_subject.result === 0) && (
            <span className="cursor-pointer whitespace-nowrap text-xs font-medium text-muted-foreground" onClick={this.onClick}>
              {_.isFinite(this.props.learner_subject.result) ? `${this.props.learner_subject.result}%` : this.props.learner_subject.result}
            </span>
          )}
          <div className="ml-auto flex shrink-0 items-center gap-2">
            <Button variant="outline" size="sm" onClick={this.onCreateLessonPlan}>Create Lesson Plan</Button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="destructive" size="icon-sm" title="Remove subject"><Trash2 /></Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem>Cancel</DropdownMenuItem>
                <DropdownMenuItem variant="destructive" onSelect={this.onRemove}>Confirm</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    )
  }
}

export default EnquiryLearnerSubjectsPartial
